import { render, staticRenderFns } from "./KustomKurir.vue?vue&type=template&id=5f20f221&scoped=true"
import script from "./KustomKurir.vue?vue&type=script&lang=js"
export * from "./KustomKurir.vue?vue&type=script&lang=js"
import style0 from "./KustomKurir.vue?vue&type=style&index=0&id=5f20f221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20f221",
  null
  
)

export default component.exports